import _ from 'lodash'
import { ErrorMessage, Form, Formik } from 'formik'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'
import { Trash2 } from 'react-feather'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router-dom'
import 'react-table/react-table.css'
import { DarkRedHover, Red } from 'src/assets/colors'
import Button from 'src/components/Button'
import FlexLayout from 'src/components/FlexLayout'
import FormField from 'src/components/Form/FormField'
import Loading from 'src/components/Loading'
import Modal from 'src/components/Modal'
import TagPrinterManager from 'src/components/TagPrinterManager'
import SupplierQueueTicket from 'src/components/Tags/SupplierQueueTicket'
import Text from 'src/components/Text'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { getFulfillmentCenterSelected } from 'src/services/fulfillmentCenter/fulfillmentCenterService'
import * as receivementService from 'src/services/receivement/receivementService'
import * as suppliersQueueApi from 'src/services/suppliersQueue/suppliersQueueApi'
import * as userApi from 'src/services/user/userApi'
import * as Yup from 'yup'
import * as S from './SupplierReceivement.styles'
import TableMui from 'src/components/TableMui'
import BilletBarcodeCell from './components/BilletBarcodeCell'
import { toast } from 'react-toastify'
import { columns } from './utils'
import TextFieldMui from 'src/components/TextFieldMui'
import { useDispatch } from 'react-redux'
import { actions } from '../../SupplierState'
import ModalNotIncludedInvoices from '../../components/ModalNotIncludedInvoices'
import ModalSelectSupplierReceivementType from '../../components/ModalSelectSupplierReceivementType'
import { SupplierReceivementTypeEnum, ReceivementAuthorizationTypeEnum, ReceivementCategoryEnum } from '../../SupplierTypes'
import { checkValueInArrayEnum } from 'src/utils/enum'
import { useForm } from 'react-hook-form'
import dayjs from 'dayjs'
import { Checkbox, FormControlLabel } from '@mui/material'

function SupplierReceivement() {
  const {
    register, clearErrors, getValues, trigger, resetField, formState: { errors: formErrors },
  } = useForm()

  const dispatch = useDispatch()
  const [user, setUser] = useState(undefined)
  const [supplier, setSupplier] = useState({
    nm_fornecedor: '',
    id_fornecedor: '',
  })
  const [dataTable, setDataTable] = useState([])
  const [errors, setErrors] = useState({})
  const [ticket, setTicket] = useState([])
  const [isFresh, setIsFresh] = useState()
  const [supplierName, setSupplierName] = useState('')
  const dataTableRef = useRef(dataTable)
  const preQueue = dataTableRef.current.some(item => !item.ar_id)

  const updateDataTable = (newState) => {
    dataTableRef.current = [...newState]
    setDataTable(newState)
  }

  const initialNotIncludedInvoices = {
    groceryInvoices: [],
    freshInvoices: []
  }
  const [notIncludedInvoices, setNotIncludedInvoices] = useState(initialNotIncludedInvoices)
  const [showModalNotIncludedInvoices, setShowModalNotIncludedInvoices] = useState(false)

  const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false)
  const [showTagManager, setShowTagManager] = useState(false)
  const [loading, setLoading] = useState(false)

  const { validateFc, fc } = useFulfillmentCenter()

  const history = useHistory()

  const userBarcodeRef = useRef()
  const invoiceAccessKeyRef = useRef()
  const billetBarCodeRef = useRef()

  const [supplierReceivementType, setSupplierReceivementType] = useState(undefined)
  const [showModalSelectSupplierReceivementType, setShowModalSelectSupplierReceivementType] = useState(false)
  const externalPurchaseOrderCodeRef = useRef()
  const [externalPurchaseOrderCode, setExternalPurchaseOrderCode] = useState('')

  const [preventDoubleClick, setPreventDoubleClick] = useState(false)

  const [hasHelper, setHasHelper] = useState(false)

  useEffect(() => {
    userBarcodeRef.current?.focus()
  }, [])

  const receivementAuthorizationTypeId = useMemo(() => {
    switch (supplierReceivementType) {
      case SupplierReceivementTypeEnum.SUPPLIER:
        return ReceivementAuthorizationTypeEnum.REGULAR
      case SupplierReceivementTypeEnum.EXTERNAL_BUYER:
        return ReceivementAuthorizationTypeEnum.EXTERNAL_ORDER
      case SupplierReceivementTypeEnum.TRANSFER:
        return ReceivementAuthorizationTypeEnum.TRANSFER_ORDER
      default:
        return 0
    }
  }, [supplierReceivementType])

  const receivementCategoryId = useMemo(() => {
    switch (supplierReceivementType) {
      case SupplierReceivementTypeEnum.SUPPLIER:
        return ReceivementCategoryEnum.NORMAL
      case SupplierReceivementTypeEnum.EXTERNAL_BUYER:
        return ReceivementCategoryEnum.EXTERNAL_PURCHASE
      case SupplierReceivementTypeEnum.TRANSFER:
        return ReceivementCategoryEnum.TRANSFER
      default:
        return 0
    }
  }, [supplierReceivementType])

  const validateBadge = async (values, resetForm) => {
    try {
      setLoading(true)
      const { data, isOk } = await userApi.validUserByBarcode(
        values.barcodeUser,
      )

      if (!isOk) {
        setErrors({ error: data.message })
        return
      }
      setUser(data.user)
      setErrors({ error: '' })
      resetForm({ values: '' })
      setShowModalSelectSupplierReceivementType(true)
    } finally {
      setLoading(false)
    }
  }

  const validateExternalPurchaseOrderCode = async (values) => {
    if (externalPurchaseOrderCode) {
      return
    }

    const orderCode = values.externalPurchaseOrderCode.trim()

    const onSuccess = () => {
      setErrors({ externalPurchaseOrderCode: '' })
      setExternalPurchaseOrderCode(orderCode)
      invoiceAccessKeyRef.current?.focus()
    }

    dispatch(actions.validateExternalPurchaseOrderCode({
      externalPurchaseOrderCode: orderCode,
      onSuccess,
      onFail: (message) => setErrors({ externalPurchaseOrderCode: message }),
      setLoading
    }))
  }

  const onChangeHasHelper = () => {
    const newCheckedState = !hasHelper

    if (!newCheckedState) {
      resetField('helperName')
      resetField('helperDocument')
    }

    setHasHelper(!hasHelper)
  }

  const barcodeAlreadyInserted = useCallback((billetsBarcode, newBilletBarcode) => {
    const billetBardodeAlreadyExist = billetsBarcode.find(billet_bardode => billet_bardode === newBilletBarcode)
    return !!billetBardodeAlreadyExist
  }, [])

  const onSubmitAddBilletBarcode = (id, newBilletBarcode, onSuccessValidate) => {
    const billetBarcode = newBilletBarcode.trim()
    dispatch(actions.validateBilletBarcode({
      barcode: billetBarcode,
      onFail: toast.error,
      onSuccess: () => handleAddBilletBarcode(id, billetBarcode, onSuccessValidate)
    }))
  }

  const handleAddBilletBarcode = useCallback((id, newBilletBarcode, onSuccessValidate) => {
    const newBilletBarcodeFormatted = newBilletBarcode.trim()
    const invoiceIndex = dataTableRef.current.findIndex(
      (item) => item.invoice_number === id,
    ) 

    let newState = _.cloneDeep(dataTableRef.current)
    const billetsBarcode = newState[invoiceIndex].billets_barcode.props.billetsBarcode

    if (barcodeAlreadyInserted(billetsBarcode, newBilletBarcodeFormatted)) {
      toast.error('Boleto já inserido!')
      return
    }

    newState[invoiceIndex].billets_barcode.props.billetsBarcode = [
      ...billetsBarcode,
      newBilletBarcodeFormatted,
    ]

    updateDataTable(newState)

    onSuccessValidate()
  }, [dataTableRef.current])

  const onSubmitAddInvoice = async (values, resetForm) => {
    if (preventDoubleClick) {
      return
    }
  
    setPreventDoubleClick(true)

    const newBilletBarcodeFormatted = values.billetBarCode.trim()

    const onFail = (message) => {
      setPreventDoubleClick(false)
      toast.error(message)
    }

    if(newBilletBarcodeFormatted){
      dispatch(actions.validateBilletBarcode({
        barcode: newBilletBarcodeFormatted,
        onFail,
        onSuccess: () => handleAddInvoice(values, resetForm)
      }))
    }else{
      handleAddInvoice(values, resetForm)
    }
  }

  const handleAddInvoice = async (values, resetForm) => {
    try {
      setLoading(true)

      setErrors({ error: '' })

      const fc = getFulfillmentCenterSelected()
      const { data, isOk } = await receivementService.getInvoiceToQueue(
        values.invoiceAccessKey.trim(),
        fc?.id,
        receivementAuthorizationTypeId,
        externalPurchaseOrderCode,
      )

      if (!isOk) {
        setErrors({ error: data.message })
        return
      }

      const invoiceAccessKey = data.ar?.invoice_access_key || data.invoice_key

      const invoiceIndex = dataTableRef.current.findIndex(
        (item) => item.invoice_number === invoiceAccessKey,
      )

      if (invoiceIndex !== -1) {
        setErrors({ error: checkValueInArrayEnum(supplierReceivementType, [SupplierReceivementTypeEnum.SUPPLIER, SupplierReceivementTypeEnum.TRANSFER]) ?
          'Nota fiscal já adicionada!' :
          'Nota fiscal ou cupom já adicionada(o)!'
        })
        return
      }

      if (isFresh === undefined && data.ar) {
        setIsFresh(data.ar.is_fresh)
      }

      if (
        !!supplier?.nm_fornecedor
        && data.supplier
        && data.supplier?.nm_fornecedor !== supplier.nm_fornecedor
        && !externalPurchaseOrderCode
      ) {
        setErrors({ error: 'AR pertencente a outro fornecedor!' })
        return
      }

      if (isFresh !== undefined && data.ar && data.ar.is_fresh !== isFresh) {
        setErrors({ error: `AR deve ser do tipo ${isFresh ? 'fresh' : 'mercearia'}` })
        return
      }

      if (!supplier?.nm_fornecedor) {
        setSupplier(data.supplier)
      }

      let newState = dataTableRef.current

      newState = [
        ...newState,
        {
          invoice_number: invoiceAccessKey,
          invoice_value: (
            data.ar?.invoice_total_value
            ? <NumberFormat
              value={data.ar?.invoice_total_value}
              displayType='text'
              decimalSeparator=','
              decimalScale={2}
              thousandSeparator='.'
              fixedDecimalScale
              prefix='R$ '
              renderText={(value) => <div>{value}</div>}
            />
            : '-'
          ),
          ar_id: data.ar?.id,
          status: data.ar?.status,
          billets_barcode: (
            <BilletBarcodeCell 
              id={invoiceAccessKey}
              billetsBarcode={[values.billetBarCode].filter(function(barcode) { return barcode.trim() })}
              onAddBilletBarcode={onSubmitAddBilletBarcode}
            />
          ),
          type: data.ar ? data.ar?.is_fresh ? 'Fresh' : 'Mercearia' : '-',
          actions: (
            <button
              style={{ background: 'none', border: 'none' }}
              onClick={() => handleRemoveInvoice(invoiceAccessKey)}
              data-testid='remove-button-test-id'
            >
              <Trash2 style={{ color: 'red', width: '19px' }} />
            </button>
          ),
        },
      ]

      updateDataTable(newState)
      resetForm({ values: '' })
      invoiceAccessKeyRef.current?.focus()
    } finally {
      setPreventDoubleClick(false)
      setLoading(false)
    }
  }

  const handleRemoveInvoice = (invoice_number) => {
    const invoiceRemoveIndex = dataTableRef.current.findIndex(
      (item) => item.invoice_number == invoice_number,
    )

    if (invoiceRemoveIndex !== -1) {
      const newState = dataTableRef.current

      newState.splice(invoiceRemoveIndex, 1)

      updateDataTable(newState)
    }

    if (dataTableRef.current.length === 0) {
      setSupplier({
        nm_fornecedor: '',
        id_fornecedor: '',
      })
      setIsFresh(undefined)
    }
  }

  const handleConfirmationModal = async (show) => {
    if (show && supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER) {
      clearErrors()

      const formValid = await trigger([
        'arrivedDate',
        'arrivedHour',
        'vehiclePlate',
        'driverName',
        'driverDocument',
        hasHelper ? 'helperName' : '',
        hasHelper ? 'helperDocument' : ''
      ].filter(field => field !== ''))

      if (!formValid) {
        return
      }
    }

    setErrors({ error: '' })
    setConfirmationModalIsOpen(show)
  }

  const handleModalNotIncludedInvoices = (groceryInvoices, freshInvoices, showConfirmation, showNotIncluded) => {
    setNotIncludedInvoices({
      groceryInvoices,
      freshInvoices
    })
    handleConfirmationModal(showConfirmation)
    setShowModalNotIncludedInvoices(showNotIncluded)
  }

  const handleModalNotIncludedInvoicesCancel = () => {
    handleModalNotIncludedInvoices(initialNotIncludedInvoices.groceryInvoices, initialNotIncludedInvoices.freshInvoices, false, false)
  }

  const handleModalNotIncludedInvoicesConfirm = () => {
    handleModalNotIncludedInvoices(initialNotIncludedInvoices.groceryInvoices, initialNotIncludedInvoices.freshInvoices, true, false)
    handleAddSupplierQueue(true)
  }

  const handleModalNotIncludedInvoicesOk = () => {
    setShowModalNotIncludedInvoices(false)
  }

  const handleAddSupplierQueue = async (checkedInvoices) => {
    try {
      if (preventDoubleClick) {
        return
      }
      setPreventDoubleClick(true)
      setLoading(true)
      validateFc()

      const ars = dataTableRef.current.map((item) => ({
        id: item.ar_id,
        nf_key: item.invoice_number,
        billets_barcode: item.billets_barcode.props.billetsBarcode,
      }))

      if (ars.length === 0) {
        setErrors({
          error:
            'Insira pelo menos uma nota fiscal para criar o recebimento',
        })
        return
      }

      const addSupplierReceivementPayload = {
        id_receivement_category: receivementCategoryId,
        ars,
        supplier_id: supplier?.id_fornecedor,
        fulfillment_center_id: fc.id,
        supplier_name: !supplier?.nm_fornecedor ? supplierName : null,
        is_fresh: isFresh,
        checked_invoices: checkedInvoices,
        external_order_code: externalPurchaseOrderCode ? externalPurchaseOrderCode : null,
      }

      if (supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER) {
        const receivementDriver = {
          arrived_at: `${getValues('arrivedDate')} ${getValues('arrivedHour')}:00`,
          vehicle_plate: getValues('vehiclePlate'),
          driver_name: getValues('driverName'),
          driver_document: getValues('driverDocument')
        }
        if (hasHelper) {
          receivementDriver.helper_name = getValues('helperName')
          receivementDriver.helper_document = getValues('helperDocument')
        }
        addSupplierReceivementPayload.receivement_driver = receivementDriver
      }

      const { data, isOk } = await suppliersQueueApi.addSupplierReceivementQueue(
        addSupplierReceivementPayload,
        user.cracha,
      )

      if (!isOk) {
        if (data.not_included_invoices) {
          setNotIncludedInvoices({
            groceryInvoices: data.not_included_invoices.grocery_invoices,
            freshInvoices: data.not_included_invoices.fresh_invoices,
          })
          setConfirmationModalIsOpen(false)
          setShowModalNotIncludedInvoices(true)
        }
        setErrors({
          error: data.message,
        })
        if (data.error_code === 'AR_ALREADY_IN_OTHER_RECEIVEMENT') {
          const rows = []
          dataTableRef.current.forEach((row) => {
            if (data.associated_ars.some(ar => ar.id === row.ar_id)) {
              rows.push({
                ...row,
                status: <span style={{ color: 'red' }}>Associada a outro recebimento</span>,
              })
            } else {
              rows.push(row)
            }
          })
          updateDataTable(rows)
        }
        return
      }

      if (data.not_included_invoices) {
        const { grocery_invoices, fresh_invoices } = data.not_included_invoices
        handleModalNotIncludedInvoices(grocery_invoices, fresh_invoices, false, true)
        return
      }

      if (receivementCategoryId === ReceivementCategoryEnum.TRANSFER) {
        history.push('/suppliers/queue')
        toast.success(data.message)
      } else {
        const obj = {
          password: data.password,
          supplier_name: supplier?.nm_fornecedor || supplierName,
          supplier_cnpj: supplier?.cnpj ?? '-',
          print_date: moment(new Date(), 'YYYY-MM-DD').format(
            'DD/MM/YYYY HH:mm:ss',
          ),
        }

        setTicket([<SupplierQueueTicket obj={obj} key={data.password} />])
        handleConfirmationModal(false)
        setShowTagManager(true)
      }
    } finally {
      setLoading(false)
      setPreventDoubleClick(false)
    }
  }

  const handleCloseTagManager = () => {
    history.push('/suppliers/queue')
  }

  const supplierNameInput = !supplier?.nm_fornecedor && !!dataTableRef.current.length && (
    <TextFieldMui
      name="supplierName"
      label="supplier.name"
      testId='supplierName'
      value={supplierName}
      onChange={(e) => setSupplierName(e.target.value)}
      autoComplete="off"
    />
  )

  return (
    <S.Container>
      <Text
        textType='header'
        text={supplierReceivementType === undefined ? 'supplierReceivement' : `Receber ${supplierReceivementType.toString()}`}
        style={S.SubTitle}
      />
      <S.InfoContainer>
        {user === undefined || supplierReceivementType === undefined ? (
          <Formik
            initialValues={{ barcodeUser: '' }}
            validationSchema={Yup.object().shape({
              barcodeUser: Yup.string().required('form.required'),
            })}
            validateOnChange={false}
            onSubmit={(values, { resetForm }) => {
              validateBadge(values, resetForm)
            }}
            validateOnBlur={false}
          >
            {() => (
              <Form>
                <FlexLayout
                  direction='column'
                  style={{ width: '35%' }}
                >
                  <FormField
                    styleContainer={{ margin: '8px 0 8px 0' }}
                    label='barcodeUser'
                    id='barcodeUser'
                    name='barcodeUser'
                    fieldRef={userBarcodeRef}
                    fieldType='password'
                  />
                </FlexLayout>

                {errors && errors.error && (
                  <Text style={{ color: 'red' }}>{errors.error}</Text>
                )}
              </Form>
            )}
          </Formik>
        ) : (
          <FlexLayout direction='column'>
            <FlexLayout direction='horizontal'>
              <S.Field>
                Operador:
                <S.FieldValue>{user.nome}</S.FieldValue>
              </S.Field>
            </FlexLayout>
            {supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER && (
              <FlexLayout direction='horizontal'>
                <S.Field>
                  Fornecedor:
                  <S.FieldValue>{supplier?.nm_fornecedor}</S.FieldValue>
                </S.Field>
              </FlexLayout>
            )}
          </FlexLayout>
        )}
      </S.InfoContainer>
      {(user && supplierReceivementType) && (
        <div style={{ margin: '20px 0 0 0' }}>
          {supplierReceivementType === SupplierReceivementTypeEnum.EXTERNAL_BUYER && (
            <Formik
              initialValues={{ externalPurchaseOrderCode: '' }}
              validationSchema={Yup.object().shape({
                externalPurchaseOrderCode: Yup.string().required('form.required'),
              })}
              validateOnChange={false}
              onSubmit={(values) => {
                validateExternalPurchaseOrderCode(values)
              }}
              validateOnBlur={false}
            >
              {() => (
                <Form>
                  <FlexLayout
                    direction='column'
                    style={{ width: '100%' }}
                  >
                    <FormField
                      styleContainer={{ margin: '8px 0 8px 0' }}
                      label='suppilerReceivement.externalPurchaseOrderCode'
                      id='externalPurchaseOrderCode'
                      name='externalPurchaseOrderCode'
                      fieldRef={externalPurchaseOrderCodeRef}
                      fieldType='text'
                      isDisabled={!!externalPurchaseOrderCode}
                      testId='external-purchase-order-code-test-id'
                    />
                  </FlexLayout>

                  {errors && errors.externalPurchaseOrderCode && (
                    <Text style={{ color: 'red' }}>{errors.externalPurchaseOrderCode}</Text>
                  )}
                </Form>
              )}
            </Formik>
          )}
          {supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER && (
            <FlexLayout direction='column'>
              <S.DriverContainer>
                <S.CustomTextField
                  name='arrivedDate'
                  id='arrivedDate'
                  label='Data'
                  type='date'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    ...register('arrivedDate', {
                      required: 'Campo obrigatório'
                    }),
                    max: dayjs().format('YYYY-MM-DD'),
                    'data-testid': 'arrived-date-test-id',
                  }}
                  error={!!formErrors.arrivedDate}
                  helperText={formErrors.arrivedDate?.message}
                  minWidth='9rem'
                  defaultValue={dayjs().format('YYYY-MM-DD')}
                />
                <S.CustomTextField
                  name='arrivedHour'
                  id='arrivedHour'
                  label='Hora'
                  type='time'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    ...register('arrivedHour', {
                      required: 'Campo obrigatório'
                    }),
                    'data-testid': 'arrived-hour-test-id',
                  }}
                  error={!!formErrors.arrivedHour}
                  helperText={formErrors.arrivedHour?.message}
                  placeholder='HH:MM'
                  minWidth='7rem'
                />
                <S.CustomTextField
                  name='vehiclePlate'
                  id='vehiclePlate'
                  label='Placa de Veículo'
                  type='text'
                  inputProps={{
                    ...register('vehiclePlate', {
                      required: 'Campo obrigatório'
                    }),
                    'data-testid': 'vehicle-plate-test-id',
                  }}
                  error={!!formErrors.vehiclePlate}
                  helperText={formErrors.vehiclePlate?.message}
                  minWidth='10rem'
                />
                <S.CustomTextField
                  name='driverName'
                  id='driverName'
                  label='Nome do Motorista'
                  type='text'
                  inputProps={{
                    ...register('driverName', {
                      required: 'Campo obrigatório'
                    }),
                    'data-testid': 'driver-name-test-id',
                  }}
                  error={!!formErrors.driverName}
                  helperText={formErrors.driverName?.message}
                  fullWidth
                />
                <S.CustomTextField
                  name='driverDocument'
                  id='driverDocument'
                  label='CPF do Motorista'
                  type='text'
                  inputProps={{
                    ...register('driverDocument', {
                      required: 'Campo obrigatório' 
                    }),
                    'data-testid': 'driver-document-test-id',
                  }}
                  error={!!formErrors.driverDocument}
                  helperText={formErrors.driverDocument?.message}
                  fullWidth
                />
              </S.DriverContainer>
              <S.DriverContainer>
                <FormControlLabel
                  sx={{
                    minWidth: '10.5rem',
                  }}
                  control={
                    <Checkbox
                      checked={hasHelper}
                      onChange={onChangeHasHelper}
                      data-testid='helper-checkbox-test-id'
                    />
                  }
                  label='Possui ajudante?'
                />
                {hasHelper && (
                  <>
                    <S.CustomTextField
                      name='helperName'
                      id='helperName'
                      label='Nome do Ajudante'
                      type='text'
                      inputProps={{
                        ...register('helperName', {
                          required: 'Campo obrigatório'
                        }),
                        'data-testid': 'helper-name-test-id',
                      }}
                      error={!!formErrors.helperName}
                      helperText={formErrors.helperName?.message}
                      fullWidth
                    />
                    <S.CustomTextField
                      name='helperDocument'
                      id='helperDocument'
                      label='CPF do Ajudante'
                      type='text'
                      inputProps={{
                        ...register('helperDocument', {
                          required: 'Campo obrigatório'
                        }),
                        'data-testid': 'helper-document-test-id',
                      }}
                      error={!!formErrors.helperDocument}
                      helperText={formErrors.helperDocument?.message}
                      fullWidth
                    />
                  </>
                )}
              </S.DriverContainer>
            </FlexLayout>
          )}
          {(checkValueInArrayEnum(supplierReceivementType, [SupplierReceivementTypeEnum.SUPPLIER, SupplierReceivementTypeEnum.TRANSFER]) ||
          (supplierReceivementType === SupplierReceivementTypeEnum.EXTERNAL_BUYER && !!externalPurchaseOrderCode)) && (
            <>
              <FlexLayout direction='column'>
                <Formik
                  initialValues={{ invoiceAccessKey: '', billetBarCode: '' }}
                  validationSchema={Yup.object().shape({
                    invoiceAccessKey: Yup.string().required('form.required'),
                  })}
                  validateOnChange={false}
                  onSubmit={(values, { resetForm }) => {
                    onSubmitAddInvoice(values, resetForm)
                  }}
                  validateOnBlur={false}
                >
                  {({ handleSubmit, setFieldValue, values }) => (
                    <S.FormContainer>
                      <Form>
                        <FlexLayout align='center' style={{ width: '100%' }}>
                          <FlexLayout
                            direction='column'
                            style={{ margin: '0 20px 0 0' }}
                          >
                            <TextFieldMui
                              label={checkValueInArrayEnum(supplierReceivementType, [SupplierReceivementTypeEnum.SUPPLIER, SupplierReceivementTypeEnum.TRANSFER]) ?
                                'supplierReceivement.form.invoiceAccessKey' :
                                'supplierReceivement.form.invoiceAccessKeyOrCoupon'
                              }
                              name='invoiceAccessKey'
                              inputRef={invoiceAccessKeyRef}
                              onKeyPress={(event) => {
                                if (event.key === 'Enter') {
                                  if (supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER) {
                                    billetBarCodeRef.current?.focus()
                                  } else if (checkValueInArrayEnum(supplierReceivementType, [SupplierReceivementTypeEnum.EXTERNAL_BUYER, SupplierReceivementTypeEnum.TRANSFER])) {
                                    handleSubmit()
                                  }
                                }
                              }}
                              onChange={(e) => setFieldValue('invoiceAccessKey', e.target.value)}
                              value={values.invoiceAccessKey}
                              testId='invoiceAccessKey'
                            />
                          </FlexLayout>
                          <FlexLayout
                            direction='column'
                            style={{ margin: '0 20px 0 0', display: supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER ? 'flex' : 'none' }}
                          >
                            <TextFieldMui
                              label='supplierReceivement.form.billetBarCode'
                              name='billetBarCode'
                              inputRef={billetBarCodeRef}
                              onKeyPress={(event) => {
                                if (supplierReceivementType === SupplierReceivementTypeEnum.SUPPLIER && event.key === 'Enter') {
                                  handleSubmit()
                                }
                              }}
                              onChange={(e) => setFieldValue('billetBarCode', e.target.value)}
                              value={values.billetBarCode}
                              testId='billetBarCode'
                            />
                          </FlexLayout>
                          <S.ButtonContainer>
                            <Button
                              type='button'
                              text='supplierReceivement.form.add'
                              style={{ position: 'relative', borderRadius: 16, margin:'6px 0 0 0' }}
                              onClick={() => handleSubmit()}
                              testId='add-button-test-id'
                            />
                          </S.ButtonContainer>
                        </FlexLayout>
                      </Form>
                      <ErrorMessage component={Text} name={'invoiceAccessKey'} style={{ color: 'red' }}/>
                      {errors && errors.error && (
                        <Text style={{ color: 'red' }}>{errors.error}</Text>
                      )}
                    </S.FormContainer>
                  )}
                </Formik>
              </FlexLayout>
              <FlexLayout
                style={{
                  margin: '10px 0 24px 0',
                }}
              >
                {dataTable && (
                  <TableMui
                    emptyLabel='Sem registros'
                    rows={dataTable}
                    columns={supplierReceivementType === SupplierReceivementTypeEnum.EXTERNAL_BUYER  ? columns.filter(column => column.id !== 'billets_barcode') : columns}
                  />
                )}
              </FlexLayout>
              <FlexLayout direction='horizontal' justify='between'>
                <Button
                  type='button'
                  text='supplierReceivement.return'
                  onClick={() => window.location.replace('/suppliers/queue')}
                  testId='return-button-test-id'
                />
                <Button
                  type='button'
                  text='supplierReceivement.receive'
                  onClick={() => handleConfirmationModal(true)}
                  testId='receive-button-test-id'
                />
              </FlexLayout>
              <Modal
                title={receivementCategoryId === ReceivementCategoryEnum.TRANSFER ? 'Receber Transferência' : 'Impressão de Senha'}
                closedButton={false}
                body={(
                  <div style={{ padding: '15px' }}>
                    <div style={{ textAlign: 'center' }}>
                      <Text
                        style={{
                          fontSize: '20px',
                          fontWeight: 'semibold',
                          padding: '20px',
                        }}
                        plainText={
                          receivementCategoryId === ReceivementCategoryEnum.TRANSFER ?
                          'Deseja receber as notas fiscais?' :
                          'Deseja receber as notas fiscais e realizar a impressão da Senha?'
                        }
                      />
                      { preQueue && <S.TextAlert>* Este recebimento irá para pré-fila!</S.TextAlert> }
                      { supplierNameInput }
                      {errors && errors.error && (
                        <Text style={{ color: 'red' }}>{errors.error}</Text>
                      )}
                    </div>
                    <div
                      style={{
                        borderTop: '1px solid #C4C4C4',
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        marginTop: '10px',
                        paddingTop: '10px',
                      }}
                    >
                      <Button
                        text='yes'
                        style={{ height: '34px' }}
                        onClick={() => handleAddSupplierQueue(false)}
                        testId='yes-button-test-id'
                      />
                      <Button
                        text='no'
                        style={{ height: '34px' }}
                        color={Red}
                        hoverColor={DarkRedHover}
                        onClick={() => handleConfirmationModal(false)}
                        testId='no-button-test-id'
                      />
                    </div>
                  </div>
                )}
                closeButton
                show={confirmationModalIsOpen}
                testId='confirmation-modal-test-id'
              />
              <ModalNotIncludedInvoices
                isShow={showModalNotIncludedInvoices}
                isFresh={isFresh}
                groceryInvoices={notIncludedInvoices.groceryInvoices}
                freshInvoices={notIncludedInvoices.freshInvoices}
                isExternalOrder={supplierReceivementType === SupplierReceivementTypeEnum.EXTERNAL_BUYER}
                onCancel={handleModalNotIncludedInvoicesCancel}
                onContinue={handleModalNotIncludedInvoicesConfirm}
                onOk={handleModalNotIncludedInvoicesOk}
              />
              {showTagManager && (
                <TagPrinterManager
                  setShowTagModal={setShowTagManager}
                  showTagModal={showTagManager}
                  labelsToPrint={ticket}
                  setLabelsToPrint={setTicket}
                  donePrint={handleCloseTagManager}
                />
              )}
            </>
          )}
        </div>
      )}
      <ModalSelectSupplierReceivementType
        isShow={showModalSelectSupplierReceivementType}
        setShow={setShowModalSelectSupplierReceivementType}
        setSupplierType={setSupplierReceivementType}
      />
      <Loading
        loading={loading}
        style={{ opacity: '0.6', zIndex: 9999, position: 'fixed', left: '0', top:'0' }}
      />
    </S.Container>
  )
}

export default SupplierReceivement
